






























import Context from "@/mixins/context";
import ForgottenPasswordFields from "@/components/app/global/auth/forgottenPasswordFields.vue";
import HasValidation from "@/mixins/HasValidation";
import { BSnackbarConfig } from "buefy/types/components";
import { Component, Mixins } from "vue-property-decorator";
import { ValidationObserver } from "vee-validate";
@Component({
  components: { ForgottenPasswordFields }
})
export default class ForgottenPasswordForm extends Mixins(
  HasValidation,
  Context
) {
  public $refs!: {
    observer: InstanceType<typeof ValidationObserver>;
    forgottenPasswordFields: ForgottenPasswordFields;
  };
  public isProcessing = false;
  public form = {};

  public created() {
    this.form = {
      ...(this.isAdmin
        ? { email: this.$_.get(this.$route.query, "email", "") }
        : { username: this.$_.get(this.$route.query, "username", "") }),
      token: ""
    };
  }

  public get isSubmitDisabled() {
    return (
      this.isProcessing ||
      (this.isAdmin
        ? this.form["email"]?.length === 0
        : this.form["username"]?.length === 0)
    );
  }

  private get loginPath() {
    return this.isAdmin ? "/admin/login" : "/login";
  }

  public async validateBeforeSubmit() {
    this.isProcessing = true;
    try {
      if (!(await this.validate())) {
        throw this.$t("_.form_invalid");
      }
      await this.$refs.forgottenPasswordFields.resetPassword();
      this.$router.push(this.loginPath);
      this.$buefy.snackbar.open({
        message: this.$t("_sentence.password_reset_requested"),
        position: "is-bottom",
        queue: false,
        duration: 10000
      } as BSnackbarConfig);
    } catch (error) {
      this.$store.dispatch("api/handleValidationError", {
        error,
        vm: this
      });
    } finally {
      this.isProcessing = false;
    }
  }
}
